import { render, staticRenderFns } from "./success.vue?vue&type=template&id=407b4f77&scoped=true"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407b4f77",
  null
  
)

export default component.exports